import { render } from "./ProjectPublicationHistoryListItemMediaItems.vue?vue&type=template&id=68a8f25c&scoped=true"
import script from "./ProjectPublicationHistoryListItemMediaItems.vue?vue&type=script&lang=js"
export * from "./ProjectPublicationHistoryListItemMediaItems.vue?vue&type=script&lang=js"

import "./ProjectPublicationHistoryListItemMediaItems.vue?vue&type=style&index=0&id=68a8f25c&lang=scss&scoped=true"

import exportComponent from "/var/www/vhosts/t-socialposterexpertise-240125/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68a8f25c"]])

export default __exports__